var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentCardFleetDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33203 2.33325C11.8462 2.33325 13.1033 2.33325 13.8843 3.16312C14.6654 3.99298 14.6654 5.32863 14.6654 7.99992C14.6654 10.6712 14.6654 12.0069 13.8843 12.8367C13.1033 13.6666 11.8462 13.6666 9.33203 13.6666H6.66536C4.1512 13.6666 2.89413 13.6666 2.11308 12.8367C1.33203 12.0069 1.33203 10.6712 1.33203 7.99992C1.33203 5.32863 1.33203 3.99298 2.11308 3.16312C2.89413 2.33325 4.1512 2.33325 6.66536 2.33325H9.33203Z",
    stroke: "#858C94",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 10.3333C4.40446 8.9084 6.9013 8.83067 7.9987 10.3333M6.83136 6.8334C6.83136 7.47773 6.30904 8.00007 5.66471 8.00007C5.02038 8.00007 4.49804 7.47773 4.49804 6.8334C4.49804 6.18908 5.02038 5.66675 5.66471 5.66675C6.30904 5.66675 6.83136 6.18908 6.83136 6.8334Z",
    stroke: "#858C94",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.33325H12.6667",
    stroke: "#858C94",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9H11.3333",
    stroke: "#858C94",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentCardFleetDriver);
export default __webpack_public_path__ + "static/media/student-card-fleet-driver.7feb976636bde0855a7661b70ab4f6f9.svg";
export { ForwardRef as ReactComponent };